import type { AxiosInstance } from 'axios';
import { applyAuthInterceptor } from './auth.interceptor';
import { applyTenantInterceptor } from './tenant.interceptor';
import { applyTokenRefreshInterceptor } from './token-refresh.interceptor';
import { applySessionInvalidationInterceptor } from './session-invalidation.interceptor';
import { applyErrorNormalizationInterceptor } from './error-normalization.interceptor';
import { applyRequestLoggingInterceptor } from './request-logging.interceptor';

export function applyInterceptors(client: AxiosInstance, enableLogging: boolean): void {
  applyAuthInterceptor(client);
  applyTenantInterceptor(client);
  applyTokenRefreshInterceptor(client);
  applySessionInvalidationInterceptor(client);
  applyErrorNormalizationInterceptor(client);
  if (enableLogging) {
    applyRequestLoggingInterceptor(client);
  }
}

export { isSessionInvalidatedError } from './session-invalidation.interceptor';
